import React, { createContext, useMemo, useState } from 'react';

export const WideContext = createContext<{
  isWide: boolean;
  setIsWide: (value: boolean) => void;
}>({ isWide: false, setIsWide: () => null });

export const WideContextProvider: React.FC<{
  children: React.ReactNode;
}> = props => {
  const [isWide, setIsWide] = useState(false);

  const contextValue = useMemo(
    () => ({
      isWide,
      setIsWide,
    }),
    [isWide]
  );

  return (
    <WideContext.Provider value={contextValue}>
      {props.children}
    </WideContext.Provider>
  );
};
